<script lang="ts">
  export let label = 'Loading…';
</script>

<div class="loading" role="status" aria-live="polite">
  <span class="loading__dot" aria-hidden="true"></span>
  <span>{label}</span>
</div>

<style>
  .loading {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-3);
    padding: var(--space-7) var(--space-4);
    color: var(--color-text-muted);
    font-size: var(--font-size-sm);
  }

  .loading__dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--color-accent-amber-500);
    animation: pulse 1.1s ease-in-out infinite;
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.35;
      transform: scale(0.85);
    }
    50% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .loading__dot {
      animation: none;
    }
  }
</style>
